import EditNoteIcon from '@assets/icons/edit-note.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import TrashIcon from '@assets/icons/trash.svg';
import { Animated, StyleSheet } from 'react-native';
import { OrderGuideRightAction } from '@/components/order-guide/order-guide-right-action';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { useTheme } from '@/contexts/theme-context';

const ORDER_ITEM_SWIPE_ACTION_WIDTH = 120;
const ORDER_ITEM_SINGLE_SWIPE_ACTION_WIDTH = 60;

interface OrderItemSwipeActionsProps {
  canEditNote: boolean;
  onEditNote: () => void;
  onRemove: () => void | Promise<void>;
  progress: Animated.Value | Animated.AnimatedInterpolation<number>;
  trackingProperties: TrackingData['properties'];
}

export const OrderItemSwipeActions: React.FC<OrderItemSwipeActionsProps> = ({
  canEditNote,
  onEditNote,
  onRemove,
  progress,
  trackingProperties,
}) => {
  const theme = useTheme();

  const editNoteWidth = canEditNote
    ? ORDER_ITEM_SWIPE_ACTION_WIDTH
    : ORDER_ITEM_SINGLE_SWIPE_ACTION_WIDTH;

  return (
    <Animated.View
      style={[
        styles.swipeActionsContainer,
        {
          transform: [
            {
              translateX: progress.interpolate({
                extrapolate: 'clamp',
                inputRange: [0, 1],
                outputRange: [editNoteWidth, 0],
              }),
            },
          ],
          width: editNoteWidth,
        },
      ]}
    >
      {canEditNote ? (
        <OrderGuideRightAction
          backgroundColor={theme.sk.color.bg.highlight.primary}
          Icon={EditNoteIcon}
          iconProps={{
            fill: theme.sk.color.icon.primary,
          }}
          onPress={onEditNote}
          text={i18n.t('edit_note_line_break')}
          trackingData={{
            name: 'order_summary_list_item.edit_note_button',
            properties: trackingProperties,
          }}
        />
      ) : null}
      <OrderGuideRightAction
        backgroundColor={theme.sk.color.icon.negative.secondary}
        Icon={TrashIcon}
        iconProps={{
          fill: theme.sk.color.bg.primary.default,
        }}
        onPress={onRemove}
        text={i18n.t('remove')}
        textColor={theme.sk.color.bg.primary.default}
        trackingData={{
          name: 'order_summary_list_item.remove_button',
          properties: trackingProperties,
        }}
      />
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  swipeActionsContainer: {
    flexDirection: 'row',
  },
});
